import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, createUrlTreeFromSnapshot } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './services/auth.service';

export const appGuard = (next: ActivatedRouteSnapshot) => {
  return inject(AuthService).authState$.pipe(
    map(authDetails=> authDetails && authDetails.uid ? true : createUrlTreeFromSnapshot(next, ['/','login']))
  )
};
export const mixedGuard = (next: ActivatedRouteSnapshot) => {
  return inject(AuthService).authState$.pipe(
    map(authDetails=> authDetails && authDetails.uid ? true : true)
  )
};
export const publicGuard = async (next: ActivatedRouteSnapshot) => {
  return inject(AuthService).authState$.pipe(
    map(authDetails=> authDetails && authDetails.uid ? createUrlTreeFromSnapshot(next, ['/','orders']) : true)
  )
}

import { HttpInterceptorFn } from '@angular/common/http';
import { Auth } from '@angular/fire/auth';
import { from, switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(Auth);
  const user = auth.currentUser;

  console.log('AUTH INTERCEPTOR:', {
    url: req.url,
    user: user?.uid
  });
  if (!user || /places\.googleapis\.com/.test(req.url)) {
    console.log('NO CURRENT USER');
    return next(req);
  }

  return from(user.getIdToken()).pipe(
    switchMap(token => {
      console.log('GOT TOKEN:', token.substring(0, 20) + '...');
      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });

      return next(authReq);
    })
  );
};